<template>
  <div>
    <b-form-row>
      <b-col lg="3">
        <b-form-group
          label="Método de Aquisição"
          label-size="sm"
          label-for="ind_metodo_aquisicao"
        >
          <b-form-select
            size="sm"
            v-model="wbs.ind_metodo_aquisicao"
            :options="
              [
                { value: 1, text: 'SBQC', type: 'C' },
                { value: 2, text: 'SISTEMA NACIONAL', type: '' },
                { value: 3, text: 'SQC', type: 'C' },
                { value: 4, text: 'LPI', type: 'O' },
                { value: 5, text: 'LPN', type: 'O' },
              ].filter(
                (f) =>
                  f.type == (this.wbs.ind_tp_contratacao == 1 ? 'O' : 'C') ||
                  f.type == ''
              )
            "
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Tipo de Revisão"
          label-size="sm"
          label-for="ind_tp_revisao"
        >
          <b-form-select
            size="sm"
            v-model="wbs.ind_tp_revisao"
            :options="cbo_tipo_revisao"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Prazo Previsto de Execução dos Serviços (Dias)"
          label-size="sm"
          label-for="prazo_previsto_licit"
        >
          <b-form-input
            size="sm"
            maxlength="20"
            id="prazo_previsto_licit"
            v-model="wbs.prazo_previsto_licit"
            trim
            autocomplete="off"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 0,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '');
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group
          label="Comentários Sistema Nacional"
          label-size="sm"
          label-for="comentarios_sn"
        >
          <b-textarea
            no-resize
            v-model="wbs.comentarios_sn"
            maxlength="5000"
            rows="2"
          ></b-textarea>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="3">
        <b-form-group
          label="Nº Processo Licitação"
          label-size="sm"
          label-for="nr_processo_licitacao"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_processo_licitacao"
            v-model="wbs.nr_processo_licitacao"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeChamamentoPublico">
        <b-form-group
          label="Nº Chamamento Público"
          label-size="sm"
          label-for="nr_chamamento_publico"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_chamamento_publico"
            v-model="wbs.nr_chamamento_publico"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeChamamentoPublico">
        <b-form-group
          label="Nº Proc. Cham. Público"
          label-size="sm"
          label-for="nr_proc_chamamento_publico"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_proc_chamamento_publico"
            v-model="wbs.nr_proc_chamamento_publico"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeChamamentoPublico">
        <b-form-group
          label="Data Chamamento Público"
          label-size="sm"
          label-for="dt_chamamento_publico"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            placeholder="DD/MM/AAAA"
            v-model="wbs.dt_chamamento_publico"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeDtEntregaMI">
        <b-form-group
          label="Data Entrega MI"
          label-size="sm"
          label-for="dt_entrega_mi"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value-type="YYYY-MM-DD"
            v-model="wbs.dt_entrega_mi"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Nº GMS" label-size="sm" label-for="nr_gms">
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_gms"
            v-model="wbs.nr_gms"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Nº Concorrência"
          label-size="sm"
          label-for="nr_concorrencia"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_concorrencia"
            v-model="wbs.nr_concorrencia"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeNrBID">
        <b-form-group label="Nº BID" label-size="sm" label-for="nr_bid">
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_bid"
            v-model="wbs.nr_bid"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Nº Portaria/Licitação"
          label-size="sm"
          label-for="nr_portaria"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_portaria"
            v-model="wbs.nr_portaria"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Valor Estimado da Licitação R$"
          label-size="sm"
          label-for="vl_estimado_licitacao"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="vl_estimado_licitacao"
            v-model="wbs.vl_estimado_licitacao"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Data de Publicação"
          label-size="sm"
          label-for="dt_public_licit"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value-type="YYYY-MM-DD"
            v-model="wbs.dt_public_licit"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="Data de Abertura"
          label-size="sm"
          label-for="dt_abert_licit"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value-type="YYYY-MM-DD"
            v-model="wbs.dt_abert_licit"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="this.wbs.ind_tp_contratacao != 1">
        <b-form-group
          label="Data de Abertura Proposta Preço"
          label-size="sm"
          label-for="cbr2_dt_abert_proposta"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value-type="YYYY-MM-DD"
            v-model="wbs.cbr2_dt_abert_proposta"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-show="getVisibilidadeDtReuniaoNegociacao">
        <b-form-group
          label="Data de Reunião de Negociação"
          label-size="sm"
          label-for="cbr2_dt_reuniao_negoc"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value-type="YYYY-MM-DD"
            v-model="wbs.cbr2_dt_reuniao_negoc"
          ></date-picker>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-tabs
          content-class="v-tab-content"
          active-nav-item-class="v-tab-active"
          small
        >
          <b-tab title="1ª Não Objeção" v-if="getVisibilidadeCRB">
            <b-form-row>
              <b-col lg="3">
                <b-form-group label="CBR" label-size="sm" label-for="cbr1">
                  <b-form-input
                    size="sm"
                    maxlength="50"
                    id="cbr1"
                    v-model="wbs.cbr1"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  label="Data"
                  label-size="sm"
                  label-for="cbr1_data"
                >
                  <date-picker
                    input-class="form-control form-control-sm"
                    :clearable="false"
                    maxlength="10"
                    placeholder="DD/MM/AAAA"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    v-model="wbs.cbr1_data"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <input
                  type="hidden"
                  id="cbr1_arquivo_id"
                  v-model="wbs.cbr1_arquivo_id"
                />
                <b-form-group
                  label="Anexo"
                  label-size="sm"
                  label-for="cbr1_arquivo_id"
                >
                  <b-input-group>
                    <b-form-file
                      v-if="(wbs.cbr1_arquivo_id || 0) == 0"
                      size="sm"
                      placeholder="Nenhum arquivo selecionado"
                      browse-text="Procurar"
                      id="fileCBR1"
                      ref="fileCBR1"
                    />

                    <b-form-input
                      v-if="wbs.cbr1_arquivo_id > 0"
                      disabled
                      size="sm"
                      id="cbr1_nome_arquivo"
                      v-model="wbs.cbr1_nome_arquivo"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        v-if="(wbs.cbr1_arquivo_id || 0) == 0"
                        @click="doUploadCBR1()"
                        variant="primary"
                        >Enviar</b-button
                      >
                      <b-button
                        v-if="(wbs.cbr1_arquivo_id || 0) > 0"
                        size="sm"
                        @click="
                          doDownloadCBR(
                            wbs.cbr1_arquivo_id,
                            wbs.cbr1_nome_arquivo
                          )
                        "
                        variant="primary"
                        >Download</b-button
                      >
                      <b-button size="sm" @click="clearCBR1()" variant="danger"
                        >Excluir</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="2ª Não Objeção" v-if="getVisibilidadeCRB">
            <b-form-row>
              <b-col lg="3">
                <b-form-group label="CBR" label-size="sm" label-for="cbr2">
                  <b-form-input
                    size="sm"
                    maxlength="50"
                    id="cbr2"
                    v-model="wbs.cbr2"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  label="Data"
                  label-size="sm"
                  label-for="cbr2_data"
                >
                  <date-picker
                    input-class="form-control form-control-sm"
                    :clearable="false"
                    maxlength="10"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    value-type="YYYY-MM-DD"
                    v-model="wbs.cbr2_data"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <input
                  type="hidden"
                  id="cbr2_arquivo_id"
                  v-model="wbs.cbr2_arquivo_id"
                />
                <b-form-group
                  label="Anexo"
                  label-size="sm"
                  label-for="cbr2_arquivo_id"
                >
                  <b-input-group>
                    <b-form-file
                      v-if="(wbs.cbr2_arquivo_id || 0) == 0"
                      size="sm"
                      placeholder="Nenhum arquivo selecionado"
                      browse-text="Procurar"
                      id="fileCBR2"
                      ref="fileCBR2"
                    />

                    <b-form-input
                      v-if="wbs.cbr2_arquivo_id > 0"
                      disabled
                      size="sm"
                      id="cbr2_nome_arquivo"
                      v-model="wbs.cbr2_nome_arquivo"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        v-if="(wbs.cbr2_arquivo_id || 0) == 0"
                        @click="doUploadCBR2()"
                        variant="primary"
                        >Enviar</b-button
                      >
                      <b-button
                        v-if="(wbs.cbr2_arquivo_id || 0) > 0"
                        size="sm"
                        @click="
                          doDownloadCBR(
                            wbs.cbr2_arquivo_id,
                            wbs.cbr2_nome_arquivo
                          )
                        "
                        variant="primary"
                        >Download</b-button
                      >
                      <b-button size="sm" @click="clearCBR2()" variant="danger"
                        >Excluir</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="3ª Não Objeção" v-if="getVisibilidadeCRB">
            <b-form-row>
              <b-col lg="3">
                <b-form-group label="CBR" label-size="sm" label-for="cbr3">
                  <b-form-input
                    size="sm"
                    maxlength="50"
                    id="cbr3"
                    v-model="wbs.cbr3"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  label="Data"
                  label-size="sm"
                  label-for="cbr3_data"
                >
                  <date-picker
                    input-class="form-control form-control-sm"
                    :clearable="false"
                    maxlength="10"
                    placeholder="DD/MM/AAAA"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    v-model="wbs.cbr3_data"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <input
                  type="hidden"
                  id="cbr3_arquivo_id"
                  v-model="wbs.cbr3_arquivo_id"
                />
                <b-form-group
                  label="Anexo"
                  label-size="sm"
                  label-for="cbr3_arquivo_id"
                >
                  <b-input-group>
                    <b-form-file
                      v-if="(wbs.cbr3_arquivo_id || 0) == 0"
                      size="sm"
                      placeholder="Nenhum arquivo selecionado"
                      browse-text="Procurar"
                      id="fileCBR3"
                      ref="fileCBR3"
                    />

                    <b-form-input
                      v-if="wbs.cbr3_arquivo_id > 0"
                      disabled
                      size="sm"
                      id="cbr3_nome_arquivo"
                      v-model="wbs.cbr3_nome_arquivo"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        v-if="(wbs.cbr3_arquivo_id || 0) == 0"
                        @click="doUploadCBR3()"
                        variant="primary"
                        >Enviar</b-button
                      >
                      <b-button
                        v-if="(wbs.cbr3_arquivo_id || 0) > 0"
                        size="sm"
                        @click="
                          doDownloadCBR(
                            wbs.cbr3_arquivo_id,
                            wbs.cbr3_nome_arquivo
                          )
                        "
                        variant="primary"
                        >Download</b-button
                      >
                      <b-button size="sm" @click="clearCBR3()" variant="danger"
                        >Excluir</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="Anexos da Licitação">
            <AnexosLicitacao :wbs="wbs" :acao="acao" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import AnexosLicitacao from "./AnexosLicitacao.vue";

export default {
  name: "TabLicitacao",
  components: { DatePicker, AnexosLicitacao },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  computed: {
    getVisibilidadeCRB: function() {
      //this.wbs.ind_tp_contratacao != 1 ||
      if (
        this.wbs.ind_tp_revisao == "2" ||
        this.wbs.ind_metodo_aquisicao == "2"
      )
        return false;
      else return true;
    },
    getVisibilidadeChamamentoPublico: function() {
      //se consultoria e sistema nacional nao exibe
      if (
        this.wbs.ind_tp_contratacao == 3 &&
        this.wbs.ind_metodo_aquisicao == 2
      )
        return false;
      // se nao for obra exibe
      if (this.wbs.ind_tp_contratacao != 1) return true;
      return false;
    },
    getVisibilidadeDtEntregaMI: function() {
      //se consultoria e sistema nacional nao exibe
      if (
        this.wbs.ind_tp_contratacao == 3 &&
        this.wbs.ind_metodo_aquisicao == 2
      )
        return false;
      // se nao for obra exibe
      if (this.wbs.ind_tp_contratacao != 1) return true;
      return false;
    },
    getVisibilidadeNrBID: function() {
      //se consultoria e sistema nacional nao exibe
      if (
        this.wbs.ind_tp_contratacao == 3 &&
        this.wbs.ind_metodo_aquisicao == 2
      )
        return false;
      // se nao for obra exibe
      if (this.wbs.ind_tp_contratacao != 1) return true;
      return false;
    },
    getVisibilidadeDtReuniaoNegociacao: function() {
      //se consultoria e sistema nacional nao exibe
      if (
        this.wbs.ind_tp_contratacao == 3 &&
        this.wbs.ind_metodo_aquisicao == 2
      )
        return false;
      // se nao for obra exibe
      if (this.wbs.ind_tp_contratacao != 1) return true;
      return false;
    },
  },
  data: function() {
    return {
      fileCBR1: "",
      cbo_tipo_revisao: [
        { value: 1, text: "EX-ANTE" },
        { value: 2, text: "EX-POST" },
        { value: 3, text: "NACIONAL" },
      ],
    };
  },
  methods: {
    doUploadCBR1() {
      let formData = new FormData();
      formData.append("file", this.$refs.fileCBR1.files[0]);
      formData.append("tipo", "1");
      axios
        .post(
          `${baseApiUrl}/bid/programawbs/${this.wbs.programa_id}/arquivo/${this.wbs.wbs_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((resp) => {
          if (resp.data && resp.data.file) {
            this.wbs.cbr1_arquivo_id = resp.data.file.arquivo_id;
            this.wbs.cbr1_nome_arquivo = resp.data.file.nome_arquivo;
          }
        })
        .catch((ex) => {
          showError(ex);
          console.log("FAILURE!!");
        });
    },
    clearCBR1() {
      if (this.wbs.cbr1_arquivo_id > 0) {
        axios
          .delete(
            `${baseApiUrl}/bid/programawbs/arquivos/${this.wbs.cbr1_arquivo_id}`
          )
          .then(() => {
            this.wbs.cbr1_arquivo_id = 0;
            this.wbs.cbr1_nome_arquivo = "";
          });
      } else {
        this.$refs.fileCBR1.value = "";
      }
    },
    doUploadCBR2() {
      let formData = new FormData();
      formData.append("file", this.$refs.fileCBR2.files[0]);
      formData.append("tipo", "2");
      axios
        .post(
          `${baseApiUrl}/bid/programawbs/${this.wbs.programa_id}/arquivo/${this.wbs.wbs_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((resp) => {
          if (resp.data && resp.data.file) {
            this.wbs.cbr2_arquivo_id = resp.data.file.arquivo_id;
            this.wbs.cbr2_nome_arquivo = resp.data.file.nome_arquivo;
          }
        })
        .catch((ex) => {
          showError(ex);
          console.log("FAILURE!!");
        });
    },
    clearCBR2() {
      if (this.wbs.cbr2_arquivo_id > 0) {
        axios
          .delete(
            `${baseApiUrl}/bid/programawbs/arquivos/${this.wbs.cbr2_arquivo_id}`
          )
          .then(() => {
            this.wbs.cbr2_arquivo_id = 0;
            this.wbs.cbr2_nome_arquivo = "";
          });
      } else {
        this.$refs.fileCBR2.value = "";
      }
    },
    doUploadCBR3() {
      let formData = new FormData();
      formData.append("file", this.$refs.fileCBR3.files[0]);
      formData.append("tipo", "3");
      axios
        .post(
          `${baseApiUrl}/bid/programawbs/${this.wbs.programa_id}/arquivo/${this.wbs.wbs_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((resp) => {
          if (resp.data && resp.data.file) {
            this.wbs.cbr3_arquivo_id = resp.data.file.arquivo_id;
            this.wbs.cbr3_nome_arquivo = resp.data.file.nome_arquivo;
          }
        })
        .catch((ex) => {
          showError(ex);
          console.log("FAILURE!!");
        });
    },
    clearCBR3() {
      if (this.wbs.cbr3_arquivo_id > 0) {
        axios
          .delete(
            `${baseApiUrl}/bid/programawbs/arquivos/${this.wbs.cbr3_arquivo_id}`
          )
          .then(() => {
            this.wbs.cbr3_arquivo_id = 0;
            this.wbs.cbr3_nome_arquivo = "";
          });
      } else {
        this.$refs.fileCBR3.value = "";
      }
    },

    doDownloadCBR(arquivoid, nome_arquivo) {
      axios({
        url: `${baseApiUrl}/bid/programawbs/arquivos/${arquivoid}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(response.data);
        var fileLink = document.createElement("a");
        fileLink.setAttribute("id", "tempDownloadLinkFile");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", nome_arquivo);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.parentNode.removeChild(fileLink);
      });
    },
  },
  mounted() {},
};
</script>
<style></style>
